<template>
  <FieldTrain ltr>
    <AppAutocomplete
      :model-value="phone.code"
      :items="toSelectItems(PHONE_CODES)"
      :custom-filter="filter"
      class="code"
      persistent-hint
      @update:model-value="phone.code = PHONE_CODES[$event as keyof typeof PHONE_CODES]"
    >
      <template #item="{ item }">
        +{{ item.title }} {{ tCountry(item.value) }}
      </template>
      <template #selection="{ item }">
        +{{ item.title }}
      </template>
    </AppAutocomplete>
    <TextField
      v-model="phone.number"
      v-bind="$attrs"
      :label="$tt('phone_number')"
      type="tel"
      append-inner-icon="mdi:phone"
      persistent-hint
    />
  </FieldTrain>
</template>

<script setup lang="ts">
import PHONE_CODES from '~/assets/phone-codes.json';
import { toSelectItems } from '~/helpers/general';
import type { CountryIso, Phone } from '~/types';

defineOptions({ inheritAttrs: false });

const phone = defineModel<Phone>({ required: true });

const { tCountry } = useLocalization();

function filter(country: CountryIso, q: string, item: { value: string }) {
  const code = item.value;
  return code.includes(q) || tCountry(country).toLowerCase().includes(q.toLowerCase());
}
</script>

<style scoped>
.code {
  max-width: max-content;
}
</style>